import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const SettingsIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 22 22"
    >
      <g transform="translate(1 1)">
        <circle
          cx="2.474"
          cy="2.474"
          r="2.474"
          transform="translate(7.526 7.526)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1046.995,139.5h-1.616a7.34,7.34,0,0,0-.649-1.572l1.143-1.143a1.339,1.339,0,0,0,0-1.886l-.942-.943a1.341,1.341,0,0,0-1.886,0L1041.9,135.1a7.388,7.388,0,0,0-1.572-.649v-1.616A1.337,1.337,0,0,0,1039,131.5h-1.333a1.338,1.338,0,0,0-1.335,1.333v1.616a7.382,7.382,0,0,0-1.571.649l-1.143-1.143a1.341,1.341,0,0,0-1.886,0l-.943.943a1.34,1.34,0,0,0,0,1.886l1.143,1.143a7.33,7.33,0,0,0-.648,1.572h-1.616a1.341,1.341,0,0,0-1.335,1.335v1.333a1.339,1.339,0,0,0,1.335,1.334h1.616a7.309,7.309,0,0,0,.648,1.572l-1.143,1.143a1.337,1.337,0,0,0,0,1.885l.943.943a1.339,1.339,0,0,0,1.886,0l1.143-1.143a7.261,7.261,0,0,0,1.571.649v1.616a1.338,1.338,0,0,0,1.335,1.334H1039a1.336,1.336,0,0,0,1.334-1.334V148.55a7.264,7.264,0,0,0,1.572-.649l1.143,1.143a1.339,1.339,0,0,0,1.886,0l.942-.943a1.338,1.338,0,0,0,0-1.885l-1.143-1.143a7.27,7.27,0,0,0,.649-1.572h1.616a1.338,1.338,0,0,0,1.334-1.334v-1.333A1.34,1.34,0,0,0,1046.995,139.5Z"
          transform="translate(-1028.329 -131.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
